import { render, staticRenderFns } from "./CustomerViewAdditionalInfoTab.vue?vue&type=template&id=7e14b0a9&scoped=true"
import script from "./CustomerViewAdditionalInfoTab.vue?vue&type=script&lang=js"
export * from "./CustomerViewAdditionalInfoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e14b0a9",
  null
  
)

export default component.exports